import { ApolloLink } from '@apollo/client/core';

export const authMiddleware = new ApolloLink((operation, forward) => {
  const token = localStorage.getItem('authToken');
  const newHeaders = {};

  if (token) {
    newHeaders.authorization = `Bearer ${token}`;
  }

  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      ...newHeaders
    }
  }));

  return forward(operation);
});
